// extracted by mini-css-extract-plugin
module.exports = {"AuditLogNestedList":"styles_AuditLogNestedList__3CpFW","nestedChild":"styles_nestedChild__3-_z5","title":"styles_title__2-FKh"};